export default __webpack_public_path__ + "static/media/web.9cd946f0.svg";